export enum Routes {
  FleetDriverRouter = "*",
  DriverSearchPageRouter = "/fleet/driver/search",
}
